import { Button, DatePicker } from "@devhop/ui";
import { formatDateForInput, parseISO } from "@/shared/lib/date-time";
import type { CfDashboardRangeParams } from "../api/types";

export type DashboardFilterState = {
  key: "today" | "7d" | "30d" | "90d" | "custom";
  params: CfDashboardRangeParams;
  from?: string; // yyyy-MM-dd (เฉพาะ custom)
  to?: string;
};

export const DEFAULT_DASHBOARD_FILTER: DashboardFilterState = {
  key: "7d",
  params: { presetDays: 7 },
};

const PRESETS: Array<{
  key: DashboardFilterState["key"];
  label: string;
  days: number;
}> = [
  { key: "today", label: "ມື້ນີ້", days: 1 },
  { key: "7d", label: "7 ມື້", days: 7 },
  { key: "30d", label: "30 ມື້", days: 30 },
  { key: "90d", label: "90 ມື້", days: 90 },
];

type Props = {
  value: DashboardFilterState;
  onChange: (next: DashboardFilterState) => void;
};

export function DashboardRangeFilter({ value, onChange }: Props) {
  return (
    <div className="flex w-full min-w-0 max-w-full flex-wrap items-center gap-1.5 sm:w-auto">
      {PRESETS.map((p) => (
        <Button
          key={p.key}
          type="button"
          size="sm"
          variant={value.key === p.key ? "default" : "outline"}
          className="h-8 shrink-0"
          onClick={() =>
            onChange({ key: p.key, params: { presetDays: p.days } })
          }
        >
          {p.label}
        </Button>
      ))}

      <DatePicker
        mode="range"
        value={{
          from: value.from ? parseISO(value.from) : undefined,
          to: value.to ? parseISO(value.to) : undefined,
        }}
        onChange={(range) => {
          const from: Date | undefined = Array.isArray(range)
            ? range[0]
            : range?.from;
          const to: Date | undefined = Array.isArray(range)
            ? range[1]
            : range?.to;
          const fromStr = from ? formatDateForInput(from) : "";
          const toStr = to ? formatDateForInput(to) : "";
          // ต้องเลือกครบทั้งสองวันถึงจะ query (กัน fetch ครึ่งช่วง)
          if (fromStr && toStr) {
            onChange({
              key: "custom",
              params: { from: fromStr, to: toStr },
              from: fromStr,
              to: toStr,
            });
          }
        }}
        placeholder="ເລືອກຊ່ວງວັນທີ"
        className="h-8 w-full min-w-0 max-w-full truncate sm:w-44 [&_button]:w-full [&_button]:min-w-0 [&_button]:truncate"
      />
    </div>
  );
}
